<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <BotmanTinker
          api-endpoint="/botman/web"
          user-id="999"
        />
      </div>
    </MadModal>
  </div>
</template>

<script>
/* eslint-disable consistent-return */

import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {
  components: {
    MadModal: () => import('@/components/MadModal'),
    BotmanTinker: () => import('@/components/BotmanTinker'),
  },

  mixins: [
    modalHelpers,
  ],

  data() {
    return {
      options: {
        width: '95%',
        height: '95%',
      },
    };
  },

  computed: {
    modalId() {
      return 'chatbot';
    },
  },

  methods: {
    onOpened() {
      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
